import React from 'react';
import { Box } from '@mui/material';

const AppLayout = ({ sidebar, banner, header, children, isMobileScreen, sidebarCollapsed }) => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {sidebar}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          ml: isMobileScreen ? 0 : (sidebarCollapsed ? 1 : 2.5),
          overflow: 'hidden',
          transition: 'margin-left 0.3s ease',
        }}
      >
        {banner}
        {header}
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
